import React from "react"
import logo from "../assets/ecsenz_logoWhite.svg"
import { context } from "@core-ts/Contexts/Context"

function useFeatureFlag(flag: string): boolean {
    const params = new URLSearchParams(window.location.search)
    const fromUrl = params.get(flag)
    if (fromUrl !== null) {
        sessionStorage.setItem(`flag_${flag}`, fromUrl)
    }
    return (sessionStorage.getItem(`flag_${flag}`) ?? fromUrl) === "true"
}
sessionStorage.clear()
export function Footer() {
    const isFullSite = useFeatureFlag("fullsite")
    return (
        <footer
            style={{
                backgroundColor: "#19191F",
                color: "#fff",
                padding: "clamp(40px, 8vw, 80px) clamp(20px, 4vw, 40px) clamp(30px, 5vw, 40px)",
                fontFamily: "system-ui, -apple-system, sans-serif",
            }}
        >
            <div
                style={{
                    maxWidth: "1400px",
                    margin: "0 auto",
                }}
            >
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                        gap: "clamp(40px, 6vw, 80px)",
                        marginBottom: "clamp(40px, 6vw, 60px)",
                    }}
                >
                    <div>
                        <h3
                            style={{
                                fontSize: "clamp(16px, 2.5vw, 18px)",
                                fontWeight: "600",
                                marginBottom: "clamp(16px, 3vw, 24px)",
                                color: "#fff",
                                letterSpacing: "-0.2px",
                            }}
                        >
                            Kontakt
                        </h3>
                        <div style={{ display: "flex", flexDirection: "column", gap: "clamp(12px, 2vw, 16px)" }}>
                            <a
                                href="tel:031 - 31 31 600"
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "12px",
                                    textDecoration: "none",
                                    color: "#ccc",
                                    transition: "color 0.2s ease",
                                }}
                                // biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                                onMouseEnter={e => (e.currentTarget.style.color = "#fff")}
                                // biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                                onMouseLeave={e => (e.currentTarget.style.color = "#ccc")}
                            >
                                {/* biome-ignore lint/a11y/noSvgWithoutTitle: <explanation> */}
                                <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
                                        fill="currentColor"
                                    />
                                </svg>
                                <span style={{ fontSize: "clamp(13px, 2vw, 14px)" }}>031 - 31 31 600</span>
                            </a>

                            <a
                                href="mailto:info@ecsenz.com"
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "12px",
                                    textDecoration: "none",
                                    color: "#ccc",
                                    transition: "color 0.2s ease",
                                }}
                                // biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                                onMouseEnter={e => (e.currentTarget.style.color = "#fff")}
                                // biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                                onMouseLeave={e => (e.currentTarget.style.color = "#ccc")}
                            >
                                {/* biome-ignore lint/a11y/noSvgWithoutTitle: <explanation> */}
                                <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
                                        fill="currentColor"
                                    />
                                </svg>
                                <span style={{ fontSize: "clamp(13px, 2vw, 14px)" }}>info@ecsenz.com</span>
                            </a>

                            <div style={{ display: "flex", alignItems: "flex-start", gap: "12px", color: "#ccc" }}>
                                {/* biome-ignore lint/a11y/noSvgWithoutTitle: <explanation> */}
                                <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginTop: "2px", flexShrink: 0 }}
                                >
                                    <path
                                        d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
                                        fill="currentColor"
                                    />
                                </svg>
                                <div style={{ fontSize: "clamp(13px, 2vw, 14px)", lineHeight: "1.5" }}>
                                    Gullbergsvassgatan 8<br />
                                    411 04 Göteborg
                                </div>
                            </div>
                        </div>
                    </div>
                    {isFullSite && <div>
                        <h3
                            style={{
                                fontSize: "clamp(16px, 2.5vw, 18px)",
                                fontWeight: "600",
                                marginBottom: "clamp(16px, 3vw, 24px)",
                                color: "#fff",
                                letterSpacing: "-0.2px",
                            }}
                        >
                            Länkar
                        </h3>
                        <div style={{ display: "flex", flexDirection: "column", gap: "clamp(10px, 2vw, 12px)" }}>
                            <a
                                href="/about"
                                style={{
                                    fontSize: "clamp(13px, 2vw, 14px)",
                                    color: "#ccc",
                                    textDecoration: "none",
                                    transition: "color 0.2s ease",
                                }}
                                // biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                                onMouseEnter={e => (e.currentTarget.style.color = "#fff")}
                                // biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                                onMouseLeave={e => (e.currentTarget.style.color = "#ccc")}
                            >
                                Om oss
                            </a>
                            <a
                                href="#contact"
                                style={{
                                    fontSize: "clamp(13px, 2vw, 14px)",
                                    color: "#ccc",
                                    textDecoration: "none",
                                    transition: "color 0.2s ease",
                                }}
                                // biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                                onMouseEnter={e => (e.currentTarget.style.color = "#fff")}
                                // biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                                onMouseLeave={e => (e.currentTarget.style.color = "#ccc")}
                            >
                                Kontakta
                            </a>
                            <a
                                href="/login"
                                style={{
                                    fontSize: "clamp(13px, 2vw, 14px)",
                                    color: "#ccc",
                                    textDecoration: "none",
                                    transition: "color 0.2s ease",
                                }}
                                // biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                                onMouseEnter={e => (e.currentTarget.style.color = "#fff")}
                                // biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                                onMouseLeave={e => (e.currentTarget.style.color = "#ccc")}
                            >
                                Logga in
                            </a>
                        </div>
                    </div>}

                    {isFullSite && (
                        <div>
                            <h3
                                style={{
                                    fontSize: "clamp(16px, 2.5vw, 18px)",
                                    fontWeight: "600",
                                    marginBottom: "clamp(16px, 3vw, 24px)",
                                    color: "#fff",
                                    letterSpacing: "-0.2px",
                                }}
                            >
                                Följ oss
                            </h3>
                            <div style={{ display: "flex", gap: "12px" }}>
                                <a
                                    href="#"
                                    style={{
                                        width: "40px",
                                        height: "40px",
                                        borderRadius: "50%",
                                        backgroundColor: "#22222A",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        transition: "background-color 0.2s ease, transform 0.2s ease",
                                        textDecoration: "none",
                                    }}
                                    onMouseEnter={e => {
                                        e.currentTarget.style.backgroundColor = "#F485C7"
                                        e.currentTarget.style.transform = "translateY(-2px)"
                                    }}
                                    onMouseLeave={e => {
                                        e.currentTarget.style.backgroundColor = "#22222A"
                                        e.currentTarget.style.transform = "translateY(0)"
                                    }}
                                >
                                    {/* biome-ignore lint/a11y/noSvgWithoutTitle: <explanation> */}
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                                        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                                    </svg>
                                </a>

                                {/* biome-ignore lint/a11y/useValidAnchor: <explanation> */}
                                <a
                                    href="#"
                                    style={{
                                        width: "40px",
                                        height: "40px",
                                        borderRadius: "50%",
                                        backgroundColor: "#22222A",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        transition: "background-color 0.2s ease, transform 0.2s ease",
                                        textDecoration: "none",
                                    }}
                                    onMouseEnter={e => {
                                        e.currentTarget.style.backgroundColor = "#F485C7"
                                        e.currentTarget.style.transform = "translateY(-2px)"
                                    }}
                                    onMouseLeave={e => {
                                        e.currentTarget.style.backgroundColor = "#22222A"
                                        e.currentTarget.style.transform = "translateY(0)"
                                    }}
                                >
                                    {/* biome-ignore lint/a11y/noSvgWithoutTitle: <explanation> */}
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                                        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                                    </svg>
                                </a>

                                {/* biome-ignore lint/a11y/useValidAnchor: <explanation> */}
                                <a
                                    href="#"
                                    style={{
                                        width: "40px",
                                        height: "40px",
                                        borderRadius: "50%",
                                        backgroundColor: "#22222A",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        transition: "background-color 0.2s ease, transform 0.2s ease",
                                        textDecoration: "none",
                                    }}
                                    onMouseEnter={e => {
                                        e.currentTarget.style.backgroundColor = "#F485C7"
                                        e.currentTarget.style.transform = "translateY(-2px)"
                                    }}
                                    onMouseLeave={e => {
                                        e.currentTarget.style.backgroundColor = "#22222A"
                                        e.currentTarget.style.transform = "translateY(0)"
                                    }}
                                >
                                    {/* biome-ignore lint/a11y/noSvgWithoutTitle: <explanation> */}
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
                                        <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                                    </svg>
                                </a>
                            </div>
                        </div>
                    )}
                </div>

                <div
                    style={{
                        display: "flex",
                        flexDirection: window.innerWidth < 768 ? "column" : "row",
                        justifyContent: "space-between",
                        alignItems: window.innerWidth < 768 ? "center" : "center",
                        gap: "20px",
                        paddingTop: "clamp(30px, 5vw, 40px)",
                        borderTop: "1px solid #2a2a30",
                    }}
                >
                    <img
                        src={logo}
                        alt="EC Senz Logo"
                        style={{
                            height: "clamp(28px, 4vw, 32px)",
                        }}
                    />

                    <div
                        style={{
                            fontSize: "clamp(11px, 2vw, 12px)",
                            color: "#888",
                            textAlign: window.innerWidth < 768 ? "center" : "right",
                        }}
                    >
                        © {context.application.version.buildYear} EC Senz AB. All rights reserved.
                    </div>
                </div>
            </div>
        </footer>
    )
}
